import { INITIAL_LOCATIONS_SEARCH_PARAMS } from 'src/views/locations/partials/Constants'
import { SET_LOCATIONS_SEARCH_PARAMS } from '../actions/actionType'

const initialState = {
  searchParams: INITIAL_LOCATIONS_SEARCH_PARAMS,
}

export default function LocationReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOCATIONS_SEARCH_PARAMS:
      return { ...state, searchParams: action.payload }
    default:
      return state
  }
}
